// src/components/Preloader.js
import React from 'react';
import { Backdrop } from '@mui/material';

const Preloader = () => (
    <Backdrop
        sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: (theme) => theme.zIndex.drawer + 1,  // Ensures it appears on top of everything
            backgroundColor: 'rgba(0, 0, 0, 0.5)',  // Fade the background
        }}
        open={true}  // This will ensure the preloader is always visible when loading
    >
        {/* Using an iframe to embed the Lottie animation */}
        <iframe
            title="preloader-animation"
            src="https://lottie.host/embed/b2868a70-67ae-4c32-8b85-ecaebbe73e8a/pCMDGzu7NJ.lottie"
            style={{
                border: "none",
                width: "200px",
                height: "200px"
            }}
        ></iframe>
    </Backdrop>
);

export default Preloader;
